/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"uyJsf6":["About"],"k4I7F8":["Impact"],"KM6m8p":["Team"],"smGSLU":["Interns"],"tDE0mP":["Content Specialists"],"HyFz7F":["Leadership"],"3JSu/M":["Supporters"],"cW8Uak":["Translators"],"astDB+":["Blog"],"Z4FGB5":["I just found your web site. I am 72 years old and I am now taking up learning where I left off. Thank you so much for all your hard work. "],"CvyHyD":["Thank you for your ongoing inspiration. I am a primary school teacher in the north of England and when the conventional education system gets on my nerves, I only need to whack on a Khan Academy and my faith in the future of education is restored!"],"IrOn9U":["Dear Khan Academy, I greatly appreciate your videos! Not only did I pass Calculus last year with a 96%, but I also discovered my love for the subject - something I had never experienced before truly understanding the mathematical content and the uses of it."],"TfQsC+":["A personalized learning resource for all ages"],"9LCf7l":["With practice exercises, instructional videos, and a personalized learning dashboard, Khan Academy empowers learners to study at their own pace, both in and out of the classroom. Covering subjects from kindergarten through early college, including math, science, reading, computing, history, art history, economics, financial literacy, SAT, MCAT, and more, Khan Academy focuses on skill mastery to help learners build the strong foundations they need to succeed in higher education and in their careers."],"qzDkRt":["Free tools for parents and teachers"],"9LS981":["We’re working hard to ensure that Khan Academy empowers coaches of all kinds to better understand what their children or students are up to and how best to help them. See at a glance whether a child or student is struggling or if she hit a streak and is now far ahead of the class. Our teacher dashboard provides a summary of class performance as a whole as well as detailed student profiles."],"UMiGXm":["Learn more about coaching"],"q376M0":["From humble beginnings to a world-class team"],"U372FN":["What started as one man tutoring his cousin has grown into a more than 150-person organization. We’re a diverse team that has come together to work on an audacious mission: to provide a free world-class education for anyone, anywhere. We are developers, teachers, designers, strategists, scientists, and content specialists who passionately believe in inspiring the world to learn. A few great people can make a big difference."],"ZQ3rQk":["Learn more about our team"],"2VkDk8":["You’re joining a global classroom"],"z4vqoD":["Millions of students from all over the world, each with their own unique story, learn at their own pace on Khan Academy every single day. Our resources are being translated into more than 36 languages in addition to the <0>Spanish</0>, <1>French</1>, and <2>Brazilian Portuguese</2> versions of our site."],"Nxx3zm":["Learn more about their stories"],"LZoO8F":["Previous testimonial"],"awYrJD":["Next testimonial"],"jFq52u":["Anyone can learn anything.  For free."],"3tCcEI":["Education is a human right.  We are a nonprofit because we believe in a free, world-class education for anyone, anywhere.  Instead of ads or subscriptions, we are supported by individual contributions from people like you.  Please join us today."],"7n8nEC":["Our mission is to provide a free, world‑class education for anyone, anywhere."]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","zh-hant","sgn-us","is","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["es","zh-hans","vi","uk","tr","te","sr","ro","pt","pl","pa","or","nb","ko","km","ka","hy","hi","fr","de","bn","bg","ar","uz","ta","sv","sk","rw","ru","pt-pt","nl","my","mr","mn","lv","lt","lol","ky","kn","kk","ja","it","id","hu","gu","fv","en-pt","el","da","cs","boxes","as","az","accents"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
